import Navbar from "@/components/feature/Navbar";
import Footer from "@/components/feature/Footer";
import AboutHero from "./components/AboutHero";
import AboutMission from "./components/AboutMission";
import AboutStats from "./components/AboutStats";
import AboutTimeline from "./components/AboutTimeline";
import AboutValues from "./components/AboutValues";

export default function AboutPage() {
  return (
    <div className="min-h-screen" style={{ backgroundColor: "var(--bg-base)" }}>
      <Navbar />
      <main>
        <AboutHero />
        <AboutStats />
        <AboutMission />
        <AboutValues />
        <AboutTimeline />
      </main>
      <Footer />
    </div>
  );
}